import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getEventsPublics, getEventsTypes, getEvents} from '../../actions';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Drawer from '@material-ui/core/Drawer';
import IconFilter from "../../assets/img/icon-filter.svg";
import Button from "@material-ui/core/Button/Button";
import CloseIcon from '@material-ui/icons/Close';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_events_search';
import ReactHtmlParser from 'react-html-parser';

class EventsSearch extends Component {
    state = {
        public: '',
        type: '',
        userClick: false,
        populateFromSearch: false,
        mobileFilterDrawerOpen: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    fetchContent() {
        const {taxonomiesLoading} = this.props;

        // Get the taxonomies terms
        this.props.getEventsPublics();
        this.props.getEventsTypes();
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            this.fetchContent();
        }

        if (this.state.public !== prevState.public || this.state.type !== prevState.type) {
            if (this.state.userClick) {
                // Only trigger a search when the user itself change the search criteria...
                this.props.getEvents(
                    1, // No offset
                    false, // Page with previous results
                    true, // Reset the search results / listing
                    this.state.public,
                    this.state.type,
                );
            }
        }

        // Auto populate dropdowns
        // -----------------------

        const {publics, types, search} = this.props;

        if (search.submitted === true) {
            if (publics.length > 0) {
                // The publics has been fetched.
                // We can now check if the user has search by public and update the active dropdown item.
                if (search.public !== '' && search.public !== prevState.public && prevState.populateFromSearch === false) {
                    this.setState({
                        'populateFromSearch': true,
                        'public': parseInt(search.public, 10)
                    });
                }
            }

            if (types.length > 0) {
                // The types has been fetched.
                // We can now check if the user has search by type and update the active dropdown item.
                if (search.type !== '' && search.type !== prevState.type && prevState.populateFromSearch === false) {
                    this.setState({
                        'populateFromSearch': true,
                        'type': parseInt(search.type, 10)
                    });
                }
            }
        }
    }

    handleChange = e => {
        // NB: setState is asynchronous!
        // If we call the getSchools function here, it'll be triggered before the state changed.
        // We'll use componentDidUpdate() => called after the state has changed

        this.setState({
            [e.target.name]: e.target.value,
            'userClick' : true,
        });
    };

    toggleFilterDrawer = (open) => () => {
        this.setState({
            mobileFilterDrawerOpen: open,
        });
    };

    render() {
        const {publics, types, taxonomiesLoading} = this.props;

        let menuItemsPublics = [];
        let menuItemsTypes = [];

        if (publics !== null && !taxonomiesLoading) {
            publics.map(term => (
                menuItemsPublics.push(<MenuItem value={term.term_id} key={term.term_id}>{term.name}</MenuItem>)
            ));
        }

        if (types !== null && !taxonomiesLoading) {
            types.map(term => (
                menuItemsTypes.push(<MenuItem value={term.term_id} key={term.term_id}>{term.name}</MenuItem>)
            ));
        }

        return (
            <Fragment>
                <section id="events-search">
                    <div className="row row-title">
                        <div className="col col-md-12 col-sm-6">
                            <h1>{ReactHtmlParser(this.props.translate('events_search.title', null, {renderInnerHtml: false}))}</h1>
                        </div>

                        <div className="col col-6 d-md-none">
                            <Button size="medium" className="btn-filter m-auto d-flex d-lg-none justify-content-center" variant="contained" color="primary" onClick={this.toggleFilterDrawer(true)}>
                                <object data={IconFilter} type="image/svg+xml">
                                    <i className="material-icons">filter</i>
                                </object>
                                <Translate id="events_search.button_filter" />
                            </Button>
                        </div>
                    </div>
                    <form autoComplete="off" className="d-none d-sm-none d-md-block">
                        <div className="row row-search">
                            <div className="col col-6 col-lg-3">
                                <FormControl fullWidth={true}>
                                    <InputLabel htmlFor="events-type">
                                        <Translate id="events_search.type_evenement" />
                                    </InputLabel>
                                    <Select
                                        value={this.state.type}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            name: 'type',
                                            id: 'events-type',
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em><Translate id="events_search.item_all" /></em>
                                        </MenuItem>
                                        {menuItemsTypes}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col col-6 col-lg-3">
                                <FormControl fullWidth={true}>
                                    <InputLabel htmlFor="events-public">
                                        <Translate id="events_search.public" />
                                    </InputLabel>
                                    <Select
                                        value={this.state.public}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            name: 'public',
                                            id: 'events-public',
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em><Translate id="events_search.item_all_levels" /></em>
                                        </MenuItem>
                                        {menuItemsPublics}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </form>
                </section>

                <Drawer id="filter-drawer" anchor="right" open={this.state.mobileFilterDrawerOpen} onClose={this.toggleFilterDrawer(false)} className="header-drawer" classes={{
                    paper: 'header-drawer-paper almost-full',
                }}>
                    <div className="wrapper wrapper-top">
                        <div className="inner">
                            <div className="drawer-title">
                                <span className="section"><Translate id="events_search.trouver_evenement" /></span>
                                <h2 className="title"><Translate id="events_search.button_filter" /></h2>
                                <Button size="large" className="btn-close-drawer" onClick={this.toggleFilterDrawer(false)}>
                                    <CloseIcon className="m-icon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper wrapper-bottom">
                        <div className="inner">
                            <form autoComplete="off">
                                <div className="row row-search">
                                    <div className="col col-12 mb-20">
                                        <FormControl fullWidth={true}>
                                            <InputLabel htmlFor="events-type">
                                                <Translate id="events_search.type_evenement" />
                                            </InputLabel>
                                            <Select
                                                value={this.state.type}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'type',
                                                    id: 'events-type',
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em><Translate id="events_search.item_all" /></em>
                                                </MenuItem>
                                                {menuItemsTypes}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col col-12 mb-20">
                                        <FormControl fullWidth={true}>
                                            <InputLabel htmlFor="events-public">
                                                <Translate id="events_search.public" />
                                            </InputLabel>
                                            <Select
                                                value={this.state.public}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'public',
                                                    id: 'events-public',
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em><Translate id="events_search.item_all_levels" /></em>
                                                </MenuItem>
                                                {menuItemsPublics}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row mt-20">
                                    <div className="col col-12">
                                        <Button onClick={this.toggleFilterDrawer(false)} size="medium" variant="contained" color="primary">
                                            <Translate id="events_search.afficher_resultats" />
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Drawer>
            </Fragment>
        );
    }
}

EventsSearch.propTypes = {
    getEventsPublics: PropTypes.func.isRequired,
    getEventsTypes: PropTypes.func.isRequired,
    getEvents: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    publics: state.events.publics,
    types: state.events.types,
    search: state.events.search,
    taxonomiesLoading: state.events.taxonomiesLoading,
});

export default connect(mapStateToProps, {getEventsPublics, getEventsTypes, getEvents})(withLocalize(EventsSearch));



// WEBPACK FOOTER //
// ./src/features/Events/components/List/EventsSearch.js